module.exports = __webpack_public_path__ + "assets/images/img_co2.png";